import { DefaultTheme } from "styled-components";

export const theme: DefaultTheme = {
  tomato: "tomato",
  kaki: "#acc6aa",
  sky: "#71a0a5",
  purple: "#a696c8",
  white: "#faf5e4",
  yellow: "#f0d78c",
  orange: { light: "#ffb677", darker: "#ffa952" },
  pink: "#ffcccc",
  red: "#e46161",
  gray: "#d9dad7",
  blue: "#005689",
  brown: "#876464",
  green: "#698474",
};
